import SignaturePad from "signature_pad"
import "../css/signature-pad.scss"

class YQQSignaturePad {
    constructor (options) {
        this.saveSignImage = options.saveSignImage

        if (options.showBackOption != undefined){
            this.showBackOption = options.showBackOption
        } else {
            this.showBackOption = true
        }

        this.pad = this.openSignaturePad()

        this.clearButton = this.pad.querySelector("[yqq-clear]")
        this.saveButton = this.pad.querySelector("[yqq-complete]")
        this.backButton = this.pad.querySelector("[yqq-back]")
        this.lanscapeBackButton = this.pad.querySelector("[yqq-landscape-back]")
        this.canvas = this.pad.querySelector("[yqq-canvas]")
        this.signaturePad = new SignaturePad(this.canvas)

        this.clearButton.addEventListener("click", this.clear.bind(this))
        this.saveButton.addEventListener("click", this.saveImage.bind(this))
        this.backButton.addEventListener("click", this.close.bind(this))
        this.lanscapeBackButton.addEventListener("click", this.close.bind(this))
        
        if (!this.showBackOption){
            this.lanscapeBackButton.parentNode.removeChild( this.lanscapeBackButton)
            this.backButton.parentNode.removeChild(this.backButton)
        }

        let resizeHandle = _ => {
            this.autoResize()
            this.resizeCanvas()
        }
        window.addEventListener("resize", resizeHandle)
        resizeHandle()

        //监听touch事件 去除水印
        let removeWatermarkHandle = _ => {
            let pad = document.getElementById("signaturePad")
            let watermark = this.pad.querySelector("[yqq-watermark]")
            pad.removeChild(watermark)
            window.removeEventListener("touchstart", removeWatermarkHandle)
        }
        window.addEventListener("touchstart", removeWatermarkHandle)
    }

    openSignaturePad () {
        let div = document.createElement("div")
        div.className = "-yqq-pad-container"
        div.innerHTML = `<div class="-yqq-header" yqq-header>
                            <div class="-yqq-title">
                                <div class="-yqq-btn-close" yqq-back>
                                    <slot name="close">
                                        <a class="-yqq-icon -yqq-icon-back">&nbsp;</a>
                                    </slot>
                                </div>
                                <p  class="-yqq-title-text">添加手写签名</p>
                            </div>
                        </div>
                        <div yqq-header-lanscape class="-yqq-header">
                            <div class="-yqq-landscape-title">
                                <div class="-yqq-btn-close" yqq-landscape-back>
                                    <slot name="close">
                                        <a class="-yqq-icon -yqq-icon-back">&nbsp;</a>
                                    </slot>
                                </div>
                                <p class="-yqq-title-text">添加手写签名</p>
                            </div>
                        </div>
                        <div id="signaturePad" class="-yqq-area-for-sign">
                            <p yqq-watermark class="-yqq-watermark">在此签名</p>
                            <canvas class="-yqq-signature-pad" yqq-canvas><p yqq-watermark class="-yqq-watermark">在此签名</p></canvas>
                        </div>
                        <div yqq-btn-title class="-yqq-btn-title">
                            <span yqq-clear class="-yqq-clear">
                                <slot name="clear" class="-yqq-icon-name">
                                    清除
                                </slot>
                            </span>
                            <span yqq-complete class="-yqq-complete">
                                <slot name="complete" class="-yqq-icon-name">
                                    完成
                                </slot>
                            </span>
                        </div>`
        document.body.appendChild(div)
        return div
    }

    autoResize () {
        let screenWidth = document.documentElement.clientWidth
        let screenHeight = document.documentElement.clientHeight
        let header = this.pad.querySelector("[yqq-header]")
        let headerLanscape = this.pad.querySelector("[yqq-header-lanscape]")
        let btnTitle = this.pad.querySelector("[yqq-btn-title]")
        let watermark = this.pad.querySelector("[yqq-watermark]")

        if (screenWidth < screenHeight) {
            headerLanscape.style.display = "none"
            header.style.display = "inline-block"
            header.style.width = screenHeight + "px"
            header.style.top = screenHeight / 2 + "px"
            header.style.left = screenWidth - 25 + "px"
            header.style.height = ""
            header.style.transform = `translate(-50%, -50%) rotate(90deg)`
            
            btnTitle.style.width = screenHeight + "px"
            btnTitle.style.left = 25 + "px"
            btnTitle.style.top = screenHeight / 2 + "px"
            btnTitle.style.transform = `translate(-50%, -50%) rotate(90deg)`

            watermark.style.width = screenHeight + "px"
            watermark.style.left = screenWidth / 2 + "px"
            watermark.style.top = screenHeight / 2 + "px"
            watermark.style.transform = `translate(-50%, -50%) rotate(90deg)`
            
            this.resizeCanvas()
        } else {
            headerLanscape.style.display = "inline-block"
            header.style.display = "none"
            headerLanscape.style.width = ""
            headerLanscape.style.top = ""
            headerLanscape.style.left = ""
            headerLanscape.style.transform = ""
            headerLanscape.style.height = screenHeight + "px"
            headerLanscape.style.left = ""

            btnTitle.style.width = ""
            btnTitle.style.left = ""
            btnTitle.style.transform = ""
            btnTitle.style.top = ""

            watermark.style.width = ""
            watermark.style.left = ""
            watermark.style.top = ""
            watermark.style.transform = ""
 
            this.resizeCanvas()
        }
    }

    resizeCanvas () {
        let screenWidth = document.documentElement.clientWidth
        let screenHeight = document.documentElement.clientHeight
        let canvas = this.canvas
        this.signaturePad.clear()
        // 兼容微信浏览器，旋转时，canvas尺寸没有及时更新的问题
        setTimeout(_ => {
            if (!canvas) return
            let ratio = Math.max(window.devicePixelRatio || 1, 1)
            canvas.width = canvas.offsetWidth * ratio
            canvas.height = canvas.offsetHeight * ratio
            canvas.getContext("2d").scale(ratio, ratio)

            let maxSize = Math.max(screenWidth, screenHeight)
            let scale = Math.max(maxSize / 600, 1.3)
            this.signaturePad.minWidth = 2 * scale
            this.signaturePad.maxWidth = 4 * scale
        }, 233)
    }
    clear () {
        this.signaturePad.clear()
    }
    saveImage () {
        if (this.signaturePad.isEmpty()) {
            alert("请输入你的签名")
        } else {
            let data = getSignatureImage("image.png", this.canvas)
            this.saveSignImage(data)
        }
    }
    close () {
        this.pad.setAttribute("class", this.pad.className + " leaveAnimation") 
        this.pad.addEventListener("animationend", _ => {
            document.body.removeChild(this.pad)
            window.removeEventListener("resize", this.resizeHandle)
        })
    }
}
function download (dataURL, filename) {
    let blob = dataURLToBlob(dataURL)
    let url = window.URL.createObjectURL(blob)

    let a = document.createElement("a")
    a.style = "display: none"
    a.href = url
    a.download = filename

    document.body.appendChild(a)
    a.click()

    window.URL.revokeObjectURL(url)
}

function dataURLToBlob (dataURL) {
    let parts = dataURL.split(";base64,")
    let contentType = parts[0].split(":")[1]
    let raw = window.atob(parts[1])
    let rawLength = raw.length
    let uInt8Array = new Uint8Array(rawLength)

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
    }

    return new Blob([uInt8Array], { type: contentType })
}

function getSignatureImage (imageType, sourceCanvas) {
    let canvas = getRoundedCanvas(sourceCanvas)
    let cutCanvas = canvasCut(canvas)
    let scaleCanvas = canvasScale(cutCanvas)
    return scaleCanvas.toDataURL.apply(scaleCanvas, arguments)
}

function getRoundedCanvas (sourceCanvas) {
    let canvas = document.createElement("canvas")
    let val = document.documentElement.clientWidth
    let screenHeight = document.documentElement.clientHeight

    if (val < screenHeight) {
        canvas.width = sourceCanvas.height
        canvas.height = sourceCanvas.width
        canvas.getContext("2d").drawImage(sourceCanvas, 0, 0)
        let sourceImageData = sourceCanvas.getContext("2d").getImageData(0, 0, sourceCanvas.width, sourceCanvas.height)
        let imageData = canvas.getContext("2d").createImageData(canvas.width, canvas.height)
        for (let x = 0; x < canvas.width; x++) {
            for (let y = 0; y < canvas.height; y++) {
                let x1 = canvas.height - y
                let y1 = x
                let pointnum = y1 * sourceCanvas.width * 4 + x1 * 4 // 原图的位置
                let newImagePointnum = y * canvas.width * 4 + x * 4 // 新图的位置
                imageData.data[newImagePointnum] = sourceImageData.data[pointnum]
                imageData.data[newImagePointnum + 1] = sourceImageData.data[pointnum + 1]
                imageData.data[newImagePointnum + 2] = sourceImageData.data[pointnum + 2]
                imageData.data[newImagePointnum + 3] = sourceImageData.data[pointnum + 3]
            }
        }
        canvas.getContext("2d").putImageData(imageData, 0, 0)
    } else {
        canvas.width = sourceCanvas.width
        canvas.height = sourceCanvas.height
        canvas.getContext("2d").drawImage(sourceCanvas, 0, 0, canvas.width, canvas.height)
    }
    return canvas
}
function canvasCut (canvas) {
    let width = canvas.width
    let height = canvas.height
    let myImageData = canvas.getContext("2d").getImageData(0, 0, width, height)
    let minX = width
    let maxX = 0
    let minY = height
    let maxY = 0

    for (let i = 0; i < height; i++) {
        for (let j = 0; j < width; j++) {
            let rgb = i * width * 4 + j * 4
            let r = myImageData.data[rgb]
            let g = myImageData.data[rgb + 1]
            let b = myImageData.data[rgb + 2]
            let a = myImageData.data[rgb + 3]
            if (r !== 0 || g !== 0 || b !== 0 || a !== 0) {
                maxY = Math.max(i, maxY)
                maxX = Math.max(j, maxX)
                minY = Math.min(i, minY)
                minX = Math.min(j, minX)
            }
        }
    }
    let cutCanvas = document.createElement("canvas")
    cutCanvas.width = maxX - minX + 1
    cutCanvas.height = maxY - minY + 1
    cutCanvas.getContext("2d").drawImage(canvas, minX, minY, cutCanvas.width, cutCanvas.height, 0, 0, cutCanvas.width, cutCanvas.height)
    return cutCanvas
}

function canvasScale (canvas) {
    let myCanvas = document.createElement("canvas")
    myCanvas.width = canvas.width
    myCanvas.height = canvas.height
    if (myCanvas.width > 300) {
        myCanvas.width = 300
        myCanvas.height = (canvas.height * 300) / canvas.width
    }

    if (myCanvas.height > 300) {
        myCanvas.height = 300
        myCanvas.width = (canvas.width * 300) / canvas.height
    }

    myCanvas.getContext("2d").drawImage(canvas, 0, 0, myCanvas.width, myCanvas.height)
    return myCanvas
}
// window.YQQSignaturePad = YQQSignaturePad

module.exports = YQQSignaturePad